import { makeStyles } from '@material-ui/core/styles';
import { IcoDocument, IcoImage, IcoExcelSheet, IcoPDFFill, IcoUpload, IcoPptFill } from '../../assets';
import MDSTheme from '../Theme';
import { FileUploaderTypeEnum } from './@types';
const useStyles = makeStyles(() => ({
  wrapper: {},
  blue: {
    '& path': {
      fill: MDSTheme.palette.blue[700],
    },
  },
  green: {
    '& path': {
      fill: MDSTheme.palette.green[600],
    },
  },
  red: {
    '& path': {
      fill: MDSTheme.palette.red[600],
    },
  },
}));
type Props = {
  type: FileUploaderTypeEnum;
};
export const FileIcon = ({ type }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      {type === FileUploaderTypeEnum.Image && <IcoImage className={classes.blue} />}
      {type === FileUploaderTypeEnum.Document && <IcoDocument className={classes.blue} />}
      {type === FileUploaderTypeEnum.Excel && <IcoExcelSheet className={classes.green} />}
      {type === FileUploaderTypeEnum.Pdf && <IcoPDFFill className={classes.red} />}
      {type === FileUploaderTypeEnum.Ppt && <IcoPptFill className={classes.red} />}
      {type === FileUploaderTypeEnum.Trademark && <IcoDocument className={classes.blue} />}
      {type === FileUploaderTypeEnum.Report && <IcoDocument className={classes.blue} />}
      {type === FileUploaderTypeEnum.All && <IcoUpload className={classes.blue} />}
    </div>
  );
};
